import React from "react";

const Footer = () => {
  return (
    <div className="Footer">
      <p className="copyright">Website by Julian Avery Leonard. </p>
      <p className="copyright">
        {" "}
        Get in touch at <a href="mailto:j@julian.design">j@julian.design.</a>
      </p>
    </div>
  );
};

export default Footer;
